import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { ConversionProvider } from './context/ConversionContext';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Home from './components/Home';
import UnifiedUnitConverter from './components/UnitConversion/UnifiedUnitConverter';
import PrivacyPolicy from './components/PrivacyPolicy';
import MaintenanceOverlay from './components/MaintenanceOverlay';
import WelcomeModal from './components/WelcomeModal';
import { DarkModeProvider } from './context/DarkModeContext';

const App = () => {
  const isMaintenance = process.env.REACT_APP_MAINTENANCE === 'true';

  if (isMaintenance) {
    return <MaintenanceOverlay />;
  }

  return (
    <HelmetProvider>
      <DarkModeProvider>
      <Router>
        <ConversionProvider>
          <div className="App">
            <Navbar />
            <div className="main-content pt-16">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/convert/:conversionType" element={<Home initialView="upload" />} />
                <Route path="/images-to-pdf" element={<Home />} />
                <Route path="/pdf-to-images" element={<Home />} />
                <Route path="/unit-conversions/*" element={<UnifiedUnitConverter />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/maintenance" element={<MaintenanceOverlay />} />
              </Routes>
            </div>
              <WelcomeModal />
            <Analytics />
            <SpeedInsights />
          </div>
        </ConversionProvider>
      </Router>
      </DarkModeProvider>
    </HelmetProvider>
  );
};

export default App;